import { render, staticRenderFns } from "./reference-content.html?vue&type=template&id=5b2ed7f6&scoped=true&"
import script from "./reference-content.js?vue&type=script&lang=js&"
export * from "./reference-content.js?vue&type=script&lang=js&"
import style0 from "./reference-content.scss?vue&type=style&index=0&id=5b2ed7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ed7f6",
  null
  
)

export default component.exports